import React, { useState } from 'react';
import { TextField, List,Typography, ListItem, ListItemText, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { useNotify } from "react-admin";
import { getPaymentTransaction,updateStatus } from './index';
import axiosWithAuthInterceptor from '../util/axiosWithAuthInterceptor';

export function PaymentStatusManager() {
    const [inputText, setInputText] = useState<any>('');
    const [error, setError] = useState<string>('');
    const [loadingFetch, setLoadingFetch] = useState<any>(false);
    const [formError, setFormError] = useState<string>('');
    const [apiData, setApiData] = useState<any>([]);
    const [open, setOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState<any>(null);
    const [newStatus, setNewStatus] = useState('');
    const notify = useNotify();

    const handleInputChange = async (event: any) => {
        const { value } = event.target;
        setInputText(value);
    };

    const fetchData = async () => {
        try {
            const res = await getPaymentTransaction(inputText);
            if (res && res.payments.length > 0) {
                setApiData(res.payments);
                setLoadingFetch(false);
            } else {
                notify(`رکوردی با این شماره تراکنش وجود ندارد`);
                setLoadingFetch(false);
            }
        } catch (err) {
            notify(`خطایی پیش آمده است!`);
            setLoadingFetch(false);
        }
    };

    const refetch = () => {
        fetchData();
    };

    const search = async (e: any) => {
        e.preventDefault();
        setApiData([]);
        setLoadingFetch(true);
        if (!error) {
            await fetchData();
        }
    };

    const handleClickOpen = (item: any) => {
        setSelectedItem(item);
        setNewStatus(item.status);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleStatusChange = (event: any) => {
        setNewStatus(event.target.value);
    };

    const handleSubmit = async () => {
        try {
            let param = {status:newStatus,id:inputText}
            const res =await updateStatus(param)
            console.log("res update",res);
            if (res.data && res.data.err) {
                notify(' خطا');
                handleClose();
                refetch();
            }else{
                notify('وضعیت با موفقیت به‌روزرسانی شد');
                handleClose();
                refetch();
            }

        } catch (error) {
            console.log('Error updating status:', error);
            notify('خطایی در به‌روزرسانی وضعیت رخ داده است');
        }
    };

    return (
        <div>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", fontFamily: "IranSans-Medium" }}>
                <form style={{ width: "100%", padding: "2em" }} action="" onSubmit={(e) => search(e)}>
                    <TextField
                        label="شماره تراکنش"
                        value={inputText}
                        onChange={handleInputChange}
                        variant="outlined"
                        fullWidth
                        error={Boolean(error)}
                        helperText={error}
                    />
                    <Button
                        onClick={(e) => search(e)}
                        fullWidth
                        disabled={loadingFetch}
                        type="submit"
                        color="primary"
                        style={{ color: "#fff", marginTop: "10px" }}
                        variant="contained"
                    >
                        {loadingFetch ? <CircularProgress size={20} /> : <span>جستجو</span>}
                    </Button>
                </form>
            </div>
            {apiData.length > 0 && (
                <List style={{ padding: "2rem", marginTop: "20px" }}>
                    {apiData.map((item: any) => (
                        <ListItem key={item.id} style={{ display: "flex",flexDirection:"column", alignItems: "start",width:"25%",border:"1px solid #d2d2d2" }}>
                         
                           <ListItemText
                           style={{textAlign:"right", marginTop:"20px",fontFamily:"IranSans-Bold"}}
                                primary={
                                    <>
                                        <Typography style={{fontFamily:"IranSans-Medium"}} variant="subtitle1"><strong>مقدار:</strong> {item.amount}</Typography>
                                        <Typography style={{fontFamily:"IranSans-Medium"}} variant="subtitle1"><strong> تاریخ ایجاد:</strong> {new Date(item.createdAt).toLocaleString('fa')}</Typography>
                                        <Typography style={{fontFamily:"IranSans-Medium"}} variant="subtitle1"><strong> شناسه مشتری:</strong> {item.customerId}</Typography>
                                        <Typography style={{fontFamily:"IranSans-Medium"}} variant="subtitle1"><strong>وضعیت:</strong> {item.status}</Typography>
                                    </>
                                }
                            />
                                <Button variant="contained" style={{color:"#fff",marginTop:"10px"}} color="primary" onClick={() => handleClickOpen(item)}>
                                 تغییر وضعیت
                            </Button>
                           
                        </ListItem>
                    ))}
                </List>
            )}
            <Dialog open={open} onClose={handleClose} maxWidth={"md"} fullWidth={true} style={{fontFamily:"IranSans-Medium"}}>
                <DialogTitle style={{fontFamily:"IranSans-Medium"}}> آپدیت وضعیت</DialogTitle>
                <DialogContent style={{fontFamily:"IranSans-Medium",margin:"20px"}}>
                    <FormControl variant="outlined" fullWidth>
                        <InputLabel>وضعیت</InputLabel>
                        <Select value={newStatus} onChange={handleStatusChange} label="Status">
                            <MenuItem value="SUCCESS">موفق</MenuItem>
                            {/* <MenuItem value="FAILED">ناموفق</MenuItem> */}
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions style={{display:"flex",justifyContent:"start"}}>
                <Button onClick={handleSubmit} color="primary">
                        ثبت
                    </Button>
                    <Button onClick={handleClose} color="primary">
                        بازگشت
                    </Button>
                   
                </DialogActions>
            </Dialog>
        </div>
    );
}